// import Lottie from 'lottie-react';
import React, { memo, useMemo } from 'react';
import { Image } from 'react-bootstrap';
// import AiVariant3StarIcon from '../../../../../../assets/json/lottieanimation/ai-variant-3-star-icon.json';
import { AiSequenceGeneratorSteps } from '../../enums';
import { getStepContent } from './helper';

/**
 *
 * AiLoadingAnimationCard Component
 *
 * This component displays an animated AI loading animation using Lott/ie.
 * It loops the animation continuously and applies a custom CSS class for styling.
 *
 * @returns React Component
 */

type AiLoadingAnimationCardProps = {
  currentStep: AiSequenceGeneratorSteps;
};

const AiLoadingAnimationCard: React.FC<AiLoadingAnimationCardProps> = ({
  currentStep,
}) => {
  const stepContent = useMemo(() => getStepContent(currentStep), [currentStep]);

  return (
    <div className="ai-loading-animation-card">
      <div className="ai-loading-animation-card-container">
        {/* Loading Text Animation */}
        <div className="ai-loading-text-animation-container">
          <div className="loop-animation-container">
            {[...stepContent, ...stepContent].map((item, index) => (
              <div
                key={`animation-${index + 1}`}
                className="ai-loading-text-animation-container-item"
              >
                {item?.icon && (
                  <Image
                    src={item.icon}
                    alt={item.text}
                    width={20}
                    height={20}
                  />
                )}
                <span className="ai-loading-text-animation-container-item-text">
                  {item.text}
                </span>
              </div>
            ))}
          </div>

          <div className="fade-area" />
        </div>
      </div>
    </div>
  );
};
export default memo(AiLoadingAnimationCard);
